<template>
    <AppLayout>
        <div class="container px-3 py-4 mx-auto md:px-6 lg:px-8">
            <div class="flex">
                <GoBack />
                <div class="mb-4 text-xl font-semibold md:text-2xl">
                    Complain by <b>{{ complain.user.name }}</b>
                </div>
            </div>

            <div
                class="px-2 py-5 space-y-12 bg-white md:px-4"
                v-html="complain.details"
            />
        </div>
    </AppLayout>
</template>

<script>
import AppLayout from '../../Layouts/AppLayout.vue';
import GoBack from '../../Components/GoBack.vue';

export default {
    name: 'ComplainShow',

    components: {
        AppLayout,
        GoBack,
    },

    props: {
        complain: {
            type: Object,
            required: true,
        },
    },
};
</script>
